import { useMemo, Dispatch } from 'react';
import { UnknownAction } from '@reduxjs/toolkit';
import throttle from 'lodash/throttle';
import { getBoundingBox, InitialMapViewState } from '@methanesat/maps';
import { setEmissionsMapBBox } from '../../../reducers';

export function useThrottledUpdateBBox(dispatch: Dispatch<UnknownAction>) {
    return useMemo(() => {
        return throttle(
            function (viewState: InitialMapViewState) {
                const bbox = getBoundingBox(viewState);
                dispatch(setEmissionsMapBBox(bbox));
            },
            500,
            { leading: false, trailing: true }
        );
    }, [dispatch]);
}
